import { useLocation } from "@tanstack/react-router"
import { useEffect } from "react"

const useResetScroll = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation()

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    document.querySelector("#scrollable")?.scrollTo(0, 0)
  }, [pathname])
}

export default useResetScroll
